import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LocationForm from './LocationForm';

function EditLocation() {
  const { id } = useParams();
  const [form, setForm] = useState({
    location_name: '',
    address_line1: '',
    address_line2: '',
    city: '',
    latitude: '',
    longitude: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchLocation = async () => {
      const res = await fetch(`/api/locations/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setForm(data);
      }
    };
    fetchLocation();
  }, [id, token]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const res = await fetch(`/api/locations/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(form)
    });

    if (res.ok) {
      alert('Location updated!');
    } else {
      const data = await res.json();
      alert(data.message || 'Error updating location');
    }
    setIsSubmitting(false);
  };

  return <LocationForm form={form} onChange={handleChange} onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
}

export default EditLocation;
